var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AppLayout',[_c('AppHeader',{attrs:{"type":"mobile-like","is-shadow":false}}),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('AppFooter'),_vm._v(" "),_c('AppOfflineBar'),_vm._v(" "),_c('AlaoNotification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }